<style lang="less" scoped>
  @import "../vars.less";

  .tag-radios-label {
    padding-top: 4px;
  }
  .tag-radios-row:not(:last-child) {
    margin-bottom: @space-small;
  }
  .radio {
    display: inline-block;
    height: 32px;
    min-width: 72px;
    text-align: center;
    line-height: 30px;
    padding: 0 @space-medium;
    font-size: 14px;
    background-color: #fff;
    color: @primary-color;
    border: 1px solid @primary-color;
    border-radius: 6px;
    transition: all .2s ease;
  }
  .radio.active {
    background-color: @primary-color;
    color: #fff;
  }
  .radio ~ .radio {
    margin-left: @space-small;
  }
  .left {
    text-align: left;
  }
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
</style>

<template>
  <div class="tag-radios van-cell van-field" role="button" tabindex="0">
    <div class="van-cell__title van-field__label tag-radios-label" :style="{
      width: labelWidth
    }">
      <span>{{ label }}</span>
    </div>
    <div class="van-cell__value van-field__value">
      <div class="tag-radios-row"  :class="{
        left: inputAlign === 'left',
        right: inputAlign === 'right',
        center: inputAlign === 'center'
      }" v-for="(row, i) of optionRows" :key="i">
        <div class="radio" v-for="radio of row" :key="radio.value"
          :class="{
            active: radio.value === value
          }"
          @click="$emit('change', radio.value)">
          {{ radio.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'tag-selector',
  props: {
    label: {
      type: String,
      default: ''
    },
    labelWidth: {
      type: String,
      default: ''
    },
    inputAlign: {
      type: String,
      default: 'left' // 'right'
    },
    options: {
      type: Array,
      default () { return [] }
    },
    value: {
      type: [String, Number]
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  computed: {
    optionRows () {
      const res = []
      for (const opt of this.options) {
        let last = res[res.length - 1]
        if (!last || last.length === 3) {
          last = []
          res.push(last)
        }
        last.push(opt)
      }

      return res
    }
  }
}
</script>
